export const ProductsBottleIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="33"
      viewBox="0 0 24 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <path
        d="M13.1797 11.4062C16.556 11.4062 19.2938 14.1432 19.2939 17.5195V29.7695C19.2939 30.8464 18.4206 31.7197 17.3438 31.7197H9.0166C7.93975 31.7197 7.06641 30.8464 7.06641 29.7695V17.5195L7.07422 17.2051C7.23801 13.975 9.90894 11.4064 13.1797 11.4062Z"
        stroke="currentColor"
      />
      <rect
        x="10.3926"
        y="8.05469"
        width="5.57487"
        height="2.81152"
        rx="1.40576"
        stroke="currentColor"
      />
      <rect
        x="11.2422"
        y="5.71875"
        width="3.95049"
        height="1.8003"
        rx="0.900152"
        stroke="currentColor"
      />
      <path
        d="M10.3555 5.45312L16.0021 5.45312"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M11.3721 0.5C12.2466 0.500206 12.96 1.21429 12.96 2.10059C12.9598 2.98672 12.2464 3.69999 11.3721 3.7002C10.4975 3.7002 9.7834 2.98685 9.7832 2.10059C9.7832 1.21416 10.4974 0.5 11.3721 0.5Z"
        stroke="currentColor"
      />
      <path
        d="M3.13281 10.6875C4.58415 10.6875 5.76562 11.8715 5.76562 13.3379C5.7656 14.8042 4.58414 15.9882 3.13281 15.9883C1.68145 15.9883 0.500027 14.8043 0.5 13.3379C0.5 11.8715 1.68143 10.6875 3.13281 10.6875Z"
        stroke="currentColor"
      />
      <path
        d="M20.1123 16.9922C21.7132 16.9922 23.0156 18.2983 23.0156 19.915C23.0155 21.5317 21.7131 22.8369 20.1123 22.8369C18.5116 22.8368 17.2091 21.5316 17.209 19.915C17.209 18.2983 18.5115 16.9923 20.1123 16.9922Z"
        stroke="currentColor"
      />
    </svg>
  );
};
